/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { useTheme } from '@emotion/react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';

const StyledButton = styled(Button)`
  margin: 0 0 2rem 0;
`;

const GridItemWithBackground = styled(Grid)`
  padding: 0 0;
  background: url('/assets/images/jobs/headquarter-bg.webp') no-repeat;
  background-size: cover;
  background-position: center;
`;

const AdvantageContainer = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  padding: 20px 0px;
  float: left;
`;

const BigGreenText = styled('div')`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 4rem;
  line-height: 80px;
  padding-left: 20px;
`;

const SmallText = styled('div')`
  font-size: 1.5rem;
  line-height: 32px;
  padding-left: 20px;
`;

const ScaledImage = styled('div')`
  overflow: hidden;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const Headquarter = (): JSX.Element => {
  const [isFullView, setFullView] = useState(false);
  const theme = useTheme();
  const lightGrey = theme.palette.grey[50];

  const handleViewToggle = () => {
    setFullView(!isFullView);
  };

  return (
    <Grid container spacing={0} style={{ marginBottom: '2rem' }}>
      <GridItemWithBackground item xs={12}>
        <Container maxWidth="md" style={{ margin: '2rem auto' }}>
          <Typography variant="h2" component="h2" style={{ color: '#ffffff' }}>
            Berliner Hauptsitz
          </Typography>
          <Typography
            variant="body1"
            component="p"
            style={{ color: '#ffffff' }}
          >
            Unser neues Büro hat eine ganz besondere Geschichte, denn
            ursprünglich wurde es als Telekom- und Vermittlungsstelle genutzt.
            Das Gebäude wurde am 15. November 1982 als Postamt eröffnet und nach
            der Wiedervereinigung von der Telekom übernommen. Von 2003 bis 2016
            wurde das Haus unter dem Namen „Postost“ von bis zu 50
            Künstler*innen als Atelierhaus genutzt. Seit Herbst 2019 begrüßen
            nun wir, im &quot;smava Tower&quot;, unsere Gäste und
            Mitarbeiter*innen.
          </Typography>
          {!isFullView && (
            <StyledButton
              variant="contained"
              color="primary"
              onClick={handleViewToggle}
            >
              Erfahre mehr...
            </StyledButton>
          )}
        </Container>
      </GridItemWithBackground>

      {isFullView && (
        <>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            style={{ backgroundColor: lightGrey }}
          >
            <AdvantageContainer>
              <BigGreenText>4</BigGreenText>&nbsp;
              <SmallText>Etagen</SmallText>
            </AdvantageContainer>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            style={{ backgroundColor: lightGrey }}
          >
            <AdvantageContainer>
              <BigGreenText>28</BigGreenText>&nbsp;
              <SmallText>Meeting-Räume</SmallText>
            </AdvantageContainer>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            style={{ backgroundColor: lightGrey }}
          >
            <AdvantageContainer>
              <BigGreenText>2</BigGreenText>&nbsp;
              <SmallText>Dachterassen</SmallText>
            </AdvantageContainer>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            style={{ backgroundColor: lightGrey }}
          >
            <AdvantageContainer>
              <BigGreenText>10+</BigGreenText>&nbsp;
              <SmallText>Essens-, Spiel- & Chill-Bereiche</SmallText>
            </AdvantageContainer>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            style={{ backgroundColor: lightGrey }}
          >
            <AdvantageContainer>
              <BigGreenText>+</BigGreenText>&nbsp;
              <SmallText>Duschen</SmallText>
            </AdvantageContainer>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            style={{ backgroundColor: lightGrey }}
          >
            <AdvantageContainer>
              <BigGreenText>+</BigGreenText>&nbsp;
              <SmallText>Fahrradstellplätze</SmallText>
            </AdvantageContainer>
          </Grid>

          <Grid item xs={12} md={6}>
            <ScaledImage>
              <img
                style={{ width: '100%', height: '100%' }}
                src="/assets/images/jobs/office_01.webp"
                alt="smava reception desk"
              />
            </ScaledImage>
          </Grid>
          <Grid item xs={12} md={6}>
            <ScaledImage>
              <img
                style={{ width: '100%', height: '100%' }}
                src="/assets/images/jobs/office_02.webp"
                alt="smava kitchen"
              />
            </ScaledImage>
          </Grid>
          <Grid item xs={12} md={6}>
            <ScaledImage>
              <img
                style={{ width: '100%', height: '100%' }}
                src="/assets/images/jobs/office_03.webp"
                alt="table tennis in smava office"
              />
            </ScaledImage>
          </Grid>
          <Grid item xs={12} md={6}>
            <ScaledImage>
              <img
                style={{ width: '100%', height: '100%' }}
                src="/assets/images/jobs/office_04.webp"
                alt="employee working at desk"
              />
            </ScaledImage>
          </Grid>
          <Grid item xs={12} md={6}>
            <ScaledImage>
              <img
                style={{ width: '100%', height: '100%' }}
                src="/assets/images/jobs/office_05.webp"
                alt="fruit basket and goodies in smava office"
              />
            </ScaledImage>
          </Grid>
          <Grid item xs={12} md={6}>
            <ScaledImage>
              <img
                style={{ width: '100%', height: '100%' }}
                src="/assets/images/jobs/office_06.webp"
                alt="rooftop terrace in smava office"
              />
            </ScaledImage>
          </Grid>

          <StyledButton
            variant="contained"
            color="primary"
            onClick={handleViewToggle}
            style={{ margin: '2rem auto' }}
          >
            Weniger anzeigen...
          </StyledButton>
        </>
      )}
    </Grid>
  );
};
